<div class="container-fluid cw-background manage-view">
  <div class="row">
    <div class="col-12">
      <mat-card class="mat-elevation-z8 my-3 pb-5" id="card">
        <div class="text-left go-back d-block">
          <button (click)="onGoBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPrefix>arrow_back_ios</mat-icon>
            Go Back
          </button>
          <h6 class="card-title-page mb-4">Edit Company:</h6>
        </div>
        <div class="row d-flex">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <app-dynamic-form
              *ngIf="questions"
              [questions]="questions"
              [disabled]="!isEdit"
              (formSubmit)="onUpdateCompany()"
            >
            </app-dynamic-form>
            <button
              *ngIf="canUpdateCompany()"
              (click)="onToggleManageCompany()"
              class="edit"
              color="primary"
              mat-icon-button
            >
              <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
            </button>
          </div>
        </div>
        <div class="row d-flex delete-btn">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <button *ngIf="currentUser.hasRight(['admin'])" (click)="onDeleteCompany()" disableRipple mat-button>
              <mat-icon matPreffix>delete</mat-icon>
              Delete Company
            </button>
          </div>
        </div>
        <div *ngIf="company" class="container-fluid cw-background">
          <div class="row">
            <div class="col-12">
              <mat-tab-group [@.disabled]="true" (selectedTabChange)="onTabChange()">
                <mat-tab label="Contracts">
                  <app-data-table
                    *ngIf="contractsTableConfig"
                    [config]="contractsTableConfig"
                    (getData)="getContracts($event)"
                    (updateData)="contractTableService.update($event)"
                  ></app-data-table>
                </mat-tab>
                <mat-tab label="Locations">
                  <app-data-table
                    *ngIf="locationsTableConfig"
                    [config]="locationsTableConfig"
                    (getData)="getLocations($event)"
                    (updateData)="locationTableService.update($event)"
                  ></app-data-table>
                </mat-tab>
                <mat-tab label="Assets">
                  <app-data-table
                    #assetTable
                    *ngIf="assetsTableConfig"
                    [config]="assetsTableConfig"
                    (getData)="getAssets($event)"
                    (updateData)="assetTableService.updateAsset($event)"
                  >
                    <ng-template #customHeader let-context>
                      <!-- Selection Action -->
                      <div class="row no-wrap" *ngIf="currentUser.hasRight(['admin', 'manager'])">
                        <div class="col-md-3">
                          <mat-form-field class="field-selector" appearance="fill">
                            <mat-label>Select an action</mat-label>
                            <mat-select (selectionChange)="selectedAction = field.value" #field>
                              <mat-option value="">--</mat-option>
                              <mat-option *ngFor="let action of assetActions" [value]="action">
                                {{ action.label | titlecase }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field class="field-selector" appearance="fill">
                            <input
                              type="text"
                              required
                              matInput
                              placeholder="Additional Information"
                              [(ngModel)]="additionalInformation"
                              value="{{ additionalInformation }}"
                            />
                          </mat-form-field>
                        </div>

                        <div class="col-md-3">
                          <button
                            class="btn btn-primary send-action-btn"
                            [disabled]="
                              {
                                selectedAction: selectedAction,
                                additionalInformation: additionalInformation,
                                selectedRows: assetTable?.config?.selection?.selectedRows
                              } | applyFunctionOrReturn: isSendActionEnabled
                            "
                            (click)="onSendAction()"
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    </ng-template>
                  </app-data-table>
                </mat-tab>
                <mat-tab label="Attachments">
                  <app-data-table
                    *ngIf="companyAttachmentsTableConfig"
                    [config]="companyAttachmentsTableConfig"
                    (getData)="getCompanyAttachments($event)"
                    (updateData)="companyAttachmentTableService.update($event)"
                  ></app-data-table>
                </mat-tab>
                <mat-tab label="Users">
                  <app-data-table
                    *ngIf="usersTableConfig"
                    [config]="usersTableConfig"
                    (getData)="getUsers($event)"
                    (updateData)="userTableService.update($event)"
                  ></app-data-table>
                  <mat-tab *ngIf="canUpdateSalesRep()" label="Partner Sales Rep.">
                    <app-data-table
                      *ngIf="salesRepsTableConfig"
                      [config]="salesRepsTableConfig"
                      (getData)="getSalesReps($event)"
                    ></app-data-table>
                  </mat-tab>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
